import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import {
    MarketingCarouselCategorieCard,
    MarketingCarouselCategoriesContainer,
    MarketingCarouselCategoriesWrapper
} from "./MarketingCarouselCategories.styles";
export interface PanelLink {
    url: string;
    label: string;
}

interface MarketingCarouselCategoriesProps {
    categoriesLinks: PanelLink[];
}

export const MarketingCarouselCategories = ({ categoriesLinks }: MarketingCarouselCategoriesProps) => (
    <MarketingCarouselCategoriesWrapper>
        <MarketingCarouselCategoriesContainer>
            <Swiper
                simulateTouch={false}
                spaceBetween={15}
                autoplay={{
                    delay: 0,
                    pauseOnMouseEnter: false,
                    disableOnInteraction: false
                }}
                loop
                speed={10000}
                slidesPerView="auto"
                modules={[Autoplay]}
            >
                {categoriesLinks.map((cat, index) => (
                    <SwiperSlide key={index}>
                        <UnstyledLink href={cat.url}>
                            <MarketingCarouselCategorieCard>
                                <V3BodyGrey35>{cat.label}</V3BodyGrey35>
                            </MarketingCarouselCategorieCard>
                        </UnstyledLink>
                    </SwiperSlide>
                ))}
            </Swiper>
        </MarketingCarouselCategoriesContainer>
    </MarketingCarouselCategoriesWrapper>
);
